module.exports = __webpack_public_path__ + "static/media/Jorge_Rafael_Coffau_Kayser.8303dc15.png";